const TYPE_USER_MODIFY = {
	ADMIN: 0,
	MANAGER: 1,
};

export default TYPE_USER_MODIFY;
